import clsx from "clsx";
import { TextProps } from "./PropsTypes";

export default function TextH1({ children, className }: TextProps) {
	return <h1 className={clsx("header-1", className)}>{children}</h1>;
}
